/**
 * LabelChips Component
 * Displays task labels as colored chips with hover tooltips
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import { getLabelChipStyles } from '../../shared/globalSX';

const LabelChips = ({ labels = [] }) => {
  if (!labels || labels.length === 0) return null;

  return (
    <Box display="flex" gap={0.5} flexWrap="wrap">
      {labels.map((label) => (
        <Tooltip 
          key={label.id} 
          title={label.name} 
          arrow
          placement="top"
          slotProps={{ tooltip: { className: 'app-tooltip' } }}
        >
          <Box sx={getLabelChipStyles(label.colour)} />
        </Tooltip>
      ))}
    </Box>
  );
};

LabelChips.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    colour: PropTypes.string
  }))
};

LabelChips.defaultProps = {
  labels: []
};

export default LabelChips;